export const AIO_HIRING_WORKFLOW_APP_MODULE_NAMES = [
  "aio_hiring",
  "aio_hiring_contract",
  "aio_hiring_contract_latam",
  "aio_hiring_mx",
  "aio_hiring_pe",
  "aio_hiring_cl",
  "aio_hiring_co",
];

export const DEFAULT_REQUISITION_ACTIVE_MODULES = [
  "hiring",
  ...AIO_HIRING_WORKFLOW_APP_MODULE_NAMES,
];
